<template>
  <div style="display: flex;justify-content: center;">
      <img src="../assets/img/pay.jpg" />
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
    };
  },
  created() {},
  computed: {
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
</style>
